import React, { useEffect, useState } from 'react';
import { Input, Button, Form, Alert, Collapse, notification, Switch } from 'antd';
import axios from 'axios';
import { hosturl } from '../libs/Constants';

const { Panel } = Collapse;

const ProfileComponent = () => {
    const [user, setUser] = useState({});
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
  
    const token = localStorage.getItem('token');

    useEffect(() => {
        fetchUserDetails();
    }, []);

    const fetchUserDetails = async () => {
        if (!token) {
            setError('Please log in to view your profile.');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.get(`${hosturl}/user-details`, {
                headers: { Authorization: `Bearer ${token}` },
                credentials: 'include',  // Ensure cookies are sent with the request
            });
            setUser(response.data.user || {});
        } catch (err) {
            setError('An unexpected error occurred. Please login.');
        } finally {
            setLoading(false);
        }
    };

    const saveChanges = async () => {
        try {
            await axios.put(`${hosturl}/update-profile`, {
                ...user,
                bankDetails: user.bankDetails,
            }, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
            });
            notification.success({
                message: 'Success',
                description: 'Profile updated successfully!',
            });
            fetchUserDetails(); // Refresh user details
        } catch (err) {
            setError('Failed to save changes.');
        }
    };

    const handleInputChange = (field, value) => {
        setUser((prevUser) => ({
            ...prevUser,
            [field]: value,
        }));
    };

    const handleBankDetailChange = (field, value) => {
        setUser((prevUser) => ({
            ...prevUser,
            bankDetails: {
                ...prevUser.bankDetails,
                [field]: value,
            },
        }));
    };

    const renderField = (label, value, field) => (
        <Form.Item label={label}>
            <Input
                value={value}
                onChange={(e) => handleInputChange(field, e.target.value)}
                placeholder={`Please enter your ${label.toLowerCase()}`}
                disabled={!editing} // Ensure this is controlled by editing state
            />
        </Form.Item>
    );

    const renderBankDetailField = (label, field) => (
        <Form.Item label={label}>
            <Input
                value={user.bankDetails?.[field] || ''}
                onChange={(e) => handleBankDetailChange(field, e.target.value)}
                placeholder={`Please enter your ${label.toLowerCase()}`}
                disabled={!editing} // Ensure this is controlled by editing state
            />
        </Form.Item>
    );

    return (
        <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
            <h2>Your Profile</h2>
            {loading && <p>Loading...</p>}
            {error && <Alert message={error} type="error" showIcon />}
            <Switch
                checked={editing}
                onChange={() => setEditing(!editing)}
                checkedChildren="View Only"
                unCheckedChildren="Editing"
                style={{ marginBottom: '20px' }}
            />
            <Form layout="vertical">
                {renderField('Username', user.username || '', 'username')}
                {renderField('Email', user.email || '', 'email')}
                {/* Conditionally render phone number field based on editing state */}
                {!editing && renderField('Phone Number', user.phoneNumber || '', 'phoneNumber')}
        
                {editing && (
                    <Button onClick={saveChanges} type="primary" style={{ marginTop: '20px' }}>
                        Save Changes
                    </Button>
                )}
            </Form>
        </div>
    );
};

export default ProfileComponent;
